




import { GroupQuery_group_sessions } from "@/graphql/generatedTypes/GroupQuery";
import formatUtils, { timezones } from "./FormatUtil";
import moment from "moment-timezone";
import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "GroupSessionTime",
  data() {
    return {
      timezones
    };
  },
  props: {
    session: Object as PropType<GroupQuery_group_sessions>
  },
  methods: {
    displayTimeZone(): string {
      const regionalTimezone = this.session.timezone?.split(" ")[0] || "";
      return this.timezones[regionalTimezone];
    },
    formattedStartTime(): string {
      const startTime = this.getTime();
      return formatUtils.prettyTime(startTime);
    },
    formattedEndTime(): string {
      let endTime = moment.utc(this.getTime(), "YYYY-MM-DD HH:mm:ss");
      if (!endTime.isValid()) {
        return "";
      }
      endTime = endTime.add(60, "minutes");
      return formatUtils.prettyTime(endTime.toISOString());
    },
    getTime(): string {
      const rawTime = this.session.time || ""; // 2000-01-01 23:30:00 UTC
      const utcTime = moment.utc(rawTime, "YYYY-MM-DD HH:mm:ss"); // 2000-01-01T23:30:00Z
      const offsetTime = utcTime.utcOffset(this.session.timezone?.split(" ")[1] || ""); // 2000-01-01T18:30:00-05:00
      return offsetTime.format("YYYY-MM-DD HH:mm:ss"); // 2000-01-01 18:30:00
    }
  }
});
